export default "__VITE_ASSET__B$3Z6yU$__"